import ConnectFundProjectPropertyModal from "./ConnectFundProjectPropertyModal"

export default ConnectFundProjectPropertyModal
